import React from 'react';
import PropTypes from 'prop-types';
import CommInstanceShape from '../../shapes/comm-instance';
import { translate } from 'react-i18next';
import AgGridReact from '../common/ag-table';
import ActiveCellComponent from './active-cell';
import YoungCellComponent from './young-cell';
import { classes } from './styles/table';
import StatusCellComponent from './status-cell';

class CommTableView extends React.Component {

  onGridReady = ({ api, columnApi }) => {
    this.gridApi = api;
    this.gridColumnApi = columnApi;
    api.sizeColumnsToFit();
  };

  render() {
    const { t, items, emptyMessage } = this.props;
    return (
      <React.Fragment>
        <div className={classes.header}>
          <h3>{t('table.header')}</h3>
        </div>
        <div
          className={`ag-theme-blue ${classes.table}`}
        >
          <AgGridReact
            identifier="name"
            name="comm"
            onGridReady={this.onGridReady}
            enableFilter
            enableSorting
            frameworkComponents={{
              ActiveCellComponent,
              YoungCellComponent,
              StatusCellComponent
            }}
            columnDefs={[
              {
                field: 'parent',
                headerName: t('table.parentHeader')
              },
              {
                field: 'status',
                headerName: t('table.statusHeader'),
                cellRenderer: 'StatusCellComponent'
              },
              {
                field: 'product',
                headerName: t('table.productHeader')
              },
              {
                field: 'name',
                headerName: t('table.nameHeader')
              },
              {
                field: 'young',
                headerName: t('table.ageHeader'),
                cellRenderer: 'YoungCellComponent'
              },
              {
                field: 'active',
                headerName: t('table.activeHeader'),
                cellRenderer: 'ActiveCellComponent'
              },
              {
                field: 'depth',
                headerName: t('table.depthHeader')
              },
              {
                field: 'numberOfEmptyReceives',
                headerName: t('table.numberOfEmptyReceivesHeader')
              }
            ]}
            rowData={items}
            localeText={{
              noRowsToShow: emptyMessage || t('table.emptyMessage')
            }}
          />
        </div>
      </React.Fragment>
    );
  }

}

CommTableView.propTypes = {
  items: PropTypes.arrayOf(
    CommInstanceShape.isRequired
  ).isRequired,
  emptyMessage: PropTypes.string,
  disabled: PropTypes.bool
};

export default translate(['comm'])(CommTableView);



// WEBPACK FOOTER //
// ./src/views/comm/table.js